import { Mail } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

const AGENCY_CONTACT_EMAIL = 'info@hiromatch.com';

export type AgencyContactContext = 'add_company' | 'signup';

interface Props {
  open: boolean;
  onClose: () => void;
  context?: AgencyContactContext;
}

export function AgencyContactModal({ open, onClose, context = 'add_company' }: Props) {
  const { t } = useLanguage();

  const subjectKey =
    context === 'signup'
      ? 'agency.contactModal.mailtoSubjectSignup'
      : 'agency.contactModal.mailtoSubjectAddCompany';
  const bodyKey =
    context === 'signup'
      ? 'agency.contactModal.mailtoBodySignup'
      : 'agency.contactModal.mailtoBodyAddCompany';

  const subject = encodeURIComponent(t(subjectKey));
  const body = encodeURIComponent(t(bodyKey));
  const mailto = `mailto:${AGENCY_CONTACT_EMAIL}?subject=${subject}&body=${body}`;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="mx-auto h-12 w-12 rounded-full bg-brand-primary/10 flex items-center justify-center mb-2">
            <Mail className="h-6 w-6 text-brand-primary" />
          </div>
          <DialogTitle className="text-center">{t('agency.contactModal.title')}</DialogTitle>
          <DialogDescription className="text-center">
            {t('agency.contactModal.body')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button variant="ghost" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button asChild>
            <a href={mailto}>{t('agency.contactModal.cta')}</a>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default AgencyContactModal;
